<template>
  <div>
    <!-- 悬浮按钮 -->
    <div v-if="userId && isCollapsed" class="floating-buttons" @mousedown="startDrag">
      <div v-if="isHovering || isclosing || mgclose" class="floating-close-button" @click="closeFloatingChat"
        title="关闭用户之声" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
        <i class="el-icon-close"></i>
      </div>
      <div v-if="isHovering" class="feedback-notice" @click="openVoiceWindow()" @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave">
        <div class="notice-content">
          <div class="notice-header">
            <div class="notice-title">
              <i class="el-icon-message"></i>
              <span>用户之声</span>
            </div>
            <div class="notice-close" @click.stop="closeFeedbackNotice">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="notice-text">您的一条条反馈，都是我们改进的方向</div>
        </div>
      </div>
      <div class="floating-buttons-group">
        <div class="floating-button" @click="openChatWindow()" @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave">
          <i class="el-icon-service" @mouseenter="isHovering = true"></i>
          <div v-if="hasUnreadNotice" class="unread-badge"></div>
        </div>
        <div v-if="checkLongId() || [99080, 102574, 102941].includes(Number(userId))" class="floating-button"
          @click="openChatlist()" @mouseenter="mgclose = true" @mouseleave="handlemgclose">
          <i class="el-icon-chat-dot-round"></i>
        </div>
      </div>
    </div>

    <!-- 右侧弹出浮窗 -->
    <el-drawer :visible.sync="drawerVisible" class="floating-chat-drawer" direction="rtl" size="460px" :z-index="2603"
      :close-on-click-modal="false" :close-on-press-escape="false" :wrapper-closable="false" @click="handleClose">
      <div slot="title">
        <i class="el-icon-message title-icon"></i> 用户之声 - 快速反馈
      </div>
      <div class="drawer-content">
        <!-- 快速反馈输入区域 -->
        <div class="feedback-input-section">
          <el-input v-model="form.question" type="textarea" :rows="6" placeholder="请输入您的问题或改进建议..."
            class="feedback-textarea" maxlength="8000"></el-input>
          <!-- 按钮区域 -->
          <div class="button-group">
            <el-button type="primary" @click="submitForm" :disabled="submitDisabled" class="submit-btn">立即提交</el-button>
            <el-button @click="openFullFeedback" :disabled="fullFeedbackDisabled" class="full-feedback-btn">
              <i class="el-icon-edit"></i> 填写全文
            </el-button>
          </div>
          <!-- 关键词标签 -->
          <div class="keywords-section">
            <span v-for="keyword in keywords" :key="keyword" class="keyword-tag" @click="addKeyword(keyword)">#{{
              keyword }}</span>
          </div>
          <!-- 单选选项 -->
          <!-- <div class="radio-section">
            <el-radio-group v-model="form.feedbackType">
              <el-radio label="suggestion">建议</el-radio>
              <el-radio label="bug">Bug</el-radio>
              <el-radio label="other">其他</el-radio>
            </el-radio-group>
          </div> -->
        </div>
        <!-- 最近30天反馈记录 -->
        <div class="recent-feedback-section">
          <div class="section-header">
            <i class="el-icon-time"></i>
            <span>最近提交</span>
            <el-tag size="small" class="time-tag">近30天</el-tag>
          </div>
          <!-- 反馈列表 -->
          <div class="feedback-list" ref="feedbackList" @scroll="handleScroll">
            <!-- 暂无数据提示 -->
            <div v-if="recentFeedbacks.length === 0 && !loading" class="no-data">
              <i class="el-icon-document"></i>
              <div>暂无数据</div>
            </div>
            <!-- 反馈列表项 -->
            <div v-for="(item, index) in recentFeedbacks" :key="index" class="feedback-item">
              <div class="feedback-header">
                <span class="feedback-title">{{ item.title }}</span>
                <el-tag :type="getStatusType(item.reply_status)" size="small" class="status-tag">{{
                  getStatusText(item.reply_status) }}</el-tag>
              </div>
              <div class="feedback-content">{{ item.content }}</div>
              <div class="feedback-footer">
                <span class="feedback-time">{{ item.create_time }}</span>
                <a href="javascript:void(0)" class="feedback-detail" @click="viewFeedbackDetail(item)">
                  {{ item.reply_status === 'replied' ? '查看结果' : '详情' }}
                </a>
              </div>
            </div>
            <!-- 加载更多提示 -->
            <div v-if="loading" class="loading-more"><i class="el-icon-loading"></i> 加载中...</div>
            <!-- 没有更多了提示 -->
            <!-- <div v-else-if="!hasMore && recentFeedbacks.length > 0" class="loading-more">没有更多了</div> -->
          </div>
          <!-- 查看全部反馈按钮 -->
          <div class="view-all-section">
            <el-button @click="openAllFeedback" class="view-all-btn">查看全部反馈</el-button>
            <div class="feedback-tip">我们将会在24小时内处理您的反馈并更新状态</div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 填写全文弹窗 -->
    <FullFeedbackDialog :visible="fullFeedbackVisible" :user-id="userId" :long-user-id="longUserId"
      :content="form.question" @close="fullFeedbackVisible = false" />
    <!-- 查看全部反馈弹窗 -->
    <AllFeedbackDialog :visible="allFeedbackVisible" :user-id="userId" :long-user-id="longUserId"
      :recent-feedbacks="recentFeedbacks" :total="total" @close="allFeedbackVisible = false" />
    <!-- 查看反馈详情弹窗 -->
    <FeedbackDetail :visible="feedbackDetailVisible" :user-id="userId" :long-user-id="longUserId"
      :feedback-data="currentFeedback" @close="feedbackDetailVisible = false" />
    <!-- 查看反馈结果弹窗 -->
    <FeedbackView :visible="feedbackViewVisible" :feedback-data="currentFeedback" :loading="feedbackLoading"
      title="用户之声 - 查看结果" @close="feedbackViewVisible = false" />
  </div>
</template>
<script>
import FullFeedbackDialog from './FullFeedbackDialog.vue';
import AllFeedbackDialog from './AllFeedbackDialog.vue';
import FeedbackDetail from './FeedbackDetail.vue';
import FeedbackView from './FeedbackView.vue';
import { addFeedbackApi, getFeedbackList, getFeedbackDetail, getFeedbackNotice, delFeedbackNotice } from '@/api/ai/agent';
export default {
  name: "FloatingChat",
  props: {
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    // 获取longUserId
    longUserId() {
      try {
        const storedUserId = sessionStorage.getItem('userId');
        if (storedUserId) {
          const userData = JSON.parse(storedUserId);
          return userData.longId || null;
        }
      } catch (e) {
        console.warn('解析sessionStorage userId失败:', e);
      }
      return null;
    }
  },
  components: {
    FullFeedbackDialog,
    AllFeedbackDialog,
    FeedbackDetail,
    FeedbackView
  },
  data() {
    return {
      // 浮窗相关数据
      drawerVisible: false,
      drawerTitle: '',
      // 弹窗相关数据
      fullFeedbackVisible: false,
      allFeedbackVisible: false,
      feedbackDetailVisible: false,
      feedbackViewVisible: false,
      currentFeedback: {},
      // 加载状态
      feedbackLoading: false,
      // 按钮禁用状态
      submitDisabled: false,
      fullFeedbackDisabled: false,
      // 提示消息控制
      lastWarningTime: 0,
      form: {
        question: '',
        contact: '',
        feedbackType: 'suggestion'
      },
      // 关键词标签
      keywords: ['体验吐槽', '功能缺失', '性能问题'],
      // 最近30天反馈记录（假数据）
      recentFeedbacks: [],
      // 加载状态
      loading: false,
      // 分页相关
      page: 1,
      pageSize: 10,
      // 总条数
      total: 0,
      // 是否还有更多数据
      hasMore: true,
      // 反馈通知相关
      feedbackNotice: null,
      showFeedbackNotice: false,
      // 鼠标悬停状态
      isHovering: false,
      isclosing: false,
      mgclose: false,
      // 未读通知标记
      hasUnreadNotice: false,
      isCollapsed: true, // 默认打开
      // 拖拽相关
      isDragging: false,
      startX: 0,
      startY: 0,
      startLeft: 0,
      startTop: 0,
      // 用于区分点击和拖拽的标志
      isClick: true,
      // 用于优化拖拽性能
      animationFrameId: null,
      // 记录是否已经拖拽过
      hasDragged: false,
      // 鼠标离开定时器
      mouseLeaveTimer: null
    }
  },
  watch: {
    drawerVisible(newVal) {
      this.$emit('drawer-changed', newVal);
    },
    userId(newVal) {
      // 当userId变化且有值时，获取反馈通知
      if (newVal) {
        // 使用 nextTick 确保路由已完全初始化
        this.$nextTick(() => {
          this.getFeedbackNoticeInfo();
        });
      }
    },
    // 监听路由变化
    '$route.path': {
      immediate: true,
      handler() {
        this.loadChatState();
      }
    }
  },
  mounted() {
    // 组件加载时，读取sessionStorage中的状态
    this.loadChatState();
    // 组件加载时，如果已有userId，则获取反馈通知
    if (this.userId) {
      // 使用 nextTick 确保路由已完全初始化
      this.$nextTick(() => {
        this.getFeedbackNoticeInfo();
      });
    }
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    // 移除窗口大小变化监听器
    window.removeEventListener('resize', this.handleWindowResize);
    // 清理动画帧
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
  },
  methods: {
    // 检查是否应该隐藏客服
    shouldHideFloatingChat() {
      const path = this.$route.path;
      // /ai/agent/voicemg不显示
      if (path === '/ai/agent/voicemg' || path.includes('/ai/mchat')) {
        return true;
      }
      // Tauri环境下/ai/preview-modal不显示
      if (typeof isTauri !== 'undefined' && isTauri && path === '/ai/preview-modal') {
        return true;
      }
      return false;
    },
    // 加载聊天状态
    loadChatState() {
      // 如果是/ai/agent页面，强制显示
      if (this.$route.path === '/ai/agent') {
        this.isCollapsed = true;
        // 保存状态到sessionStorage
        try {
          sessionStorage.setItem('myChat', 'true');
        } catch (error) {
          console.error('保存聊天状态失败:', error);
        }
        return;
      }

      try {
        const savedState = sessionStorage.getItem('myChat');
        if (savedState === 'false') {
          this.isCollapsed = false;
        }
      } catch (error) {
        console.error('读取聊天状态失败:', error);
      }
    },
    // 获取反馈通知
    async getFeedbackNoticeInfo() {
      if (!this.userId) return;
      // 检查是否在不展示客服的路由下
      if (this.shouldHideFloatingChat()) return;

      try {
        const params = {
          user_id: this.userId
        };
        const response = await getFeedbackNotice(params);
        if (response && response.code === 200) {
          if (typeof (response.data) !== "undefined" && response.data !== null) {
            this.hasUnreadNotice = true;
          } else {
            this.hasUnreadNotice = false; // 隐藏小红点
          }
        } else {
          this.hasUnreadNotice = false;
        }
      } catch (error) {
        console.error('获取反馈通知失败:', error);
      }
    },
    // 打开聊天窗口
    async openChatWindow() {
      // 如果是拖拽操作，不执行点击事件
      if (!this.isClick) {
        this.isClick = true; // 重置标志
        return;
      }

      this.isHovering = false;
      this.drawerVisible = true;
      // 重置表单
      this.form.question = '';
      this.form.contact = '';
      this.form.feedbackType = 'suggestion';
      // 重置分页参数
      this.page = 1;
      this.hasMore = true;
      // 清空现有数据
      this.recentFeedbacks = [];
      // 加载反馈列表
      await this.loadFeedbackList();
      if (this.hasUnreadNotice) {
        // 调用delFeedbackNotice接口
        try {
          await delFeedbackNotice({ user_id: this.userId });
          this.hasUnreadNotice = false; // 隐藏小红点
        } catch (error) {
          console.error('删除反馈通知失败:', error);
        }
      }
    },
    // 打开用户之声弹窗
    async openVoiceWindow() {
      // 如果是拖拽操作，不执行点击事件
      if (!this.isClick) {
        this.isClick = true; // 重置标志
        return;
      }

      // 关闭用户之声小方块
      this.isHovering = false;
      // 加载反馈列表
      await this.loadFeedbackList();
      // 执行 openAllFeedback 弹出查看全部反馈弹窗
      this.openAllFeedback();
      if (this.hasUnreadNotice) {
        // 调用delFeedbackNotice接口
        try {
          await delFeedbackNotice({ user_id: this.userId });
          this.hasUnreadNotice = false; // 隐藏小红点
        } catch (error) {
          console.error('删除反馈通知失败:', error);
        }
      }
    },

    // 加载反馈列表
    async loadFeedbackList() {
      if (!this.userId || this.loading || !this.hasMore) return;

      this.loading = true;
      try {
        const params = {
          user_id: this.userId,
          order_by: '-id',
          page: this.page,
          page_size: this.pageSize
        };
        const response = await getFeedbackList(params);
        if (response && response.code === 200 && response.data) {
          const feedbacks = response.data.data;
          if (this.page === 1) {
            this.recentFeedbacks = feedbacks;
          } else {
            this.recentFeedbacks = [...this.recentFeedbacks, ...feedbacks];
          }
          // 使用 total 判断是否还有更多数据
          const totalCount = response.data.total || 0;
          this.total = totalCount;
          this.hasMore = this.recentFeedbacks.length < totalCount;
        }
      } catch (error) {
        console.error('获取反馈列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    openChatlist() {
      // 如果是拖拽操作，不执行点击事件
      if (!this.isClick) {
        this.isClick = true; // 重置标志
        return;
      }

      // 避免重复跳转到当前页面
      if (this.$route.path === '/ai/agent/voicemg') {
        return;
      }
      this.$router.push({
        path: '/ai/agent/voicemg'
      });
    },
    // 提交表单
    async submitForm() {
      if (!this.form.question || !this.form.question.trim()) {
        const now = Date.now();
        if (now - this.lastWarningTime > 3000) {
          this.$message.warning('请输入您的问题');
          this.lastWarningTime = now;
        }
        return;
      }
      // 禁用按钮
      this.submitDisabled = true;

      // 映射反馈类型
      const fbTypeMap = {
        'suggestion': 'module',
        'bug': 'system',
        'other': 'other'
      };

      // 生成标题（前200字加省略号）
      const title = this.form.question.substring(0, 200) + (this.form.question.length > 200 ? '...' : '');

      // 构建提交参数
      const params = {
        user_id: this.userId,
        fb_type: fbTypeMap[this.form.feedbackType] || 'other',
        title: title,
        content: this.form.question,
        fb_module: 'system',
        attachment: []
      };

      try {
        // 调用提交反馈接口
        const response = await addFeedbackApi(params);
        if (response && response.code === 200) {
          this.$message.success('提交成功，我们会尽快回复您');
          // 模拟添加到最近反馈列表
          // this.recentFeedbacks.unshift({
          //   title: title,
          //   content: this.form.question,
          //   time: new Date().toLocaleString('zh-CN'),
          //   status: '已收到'
          // });
          // 重置表单
          this.form.question = '';
          // 关闭抽屉
          this.drawerVisible = false;
        } else {
          this.$message.error(response.message || '提交失败，请稍后重试');
        }
      } catch (error) {
        console.error('提交反馈失败:', error);
        this.$message.error('提交失败，请稍后重试');
      } finally {
        // 3秒后启用按钮
        setTimeout(() => {
          this.submitDisabled = false;
        }, 3000);
      }
    },
    handleClose() {
      this.drawerVisible = false;
    },
    // 添加关键词到文本框
    addKeyword(keyword) {
      if (this.form.question) {
        this.form.question += ' #' + keyword;
      } else {
        this.form.question = '#' + keyword;
      }
    },
    // 打开填写全文弹窗
    openFullFeedback() {
      // 禁用按钮
      this.fullFeedbackDisabled = true;
      this.fullFeedbackVisible = true;
      // 关闭主抽屉
      this.drawerVisible = false;
      // 3秒后启用按钮
      setTimeout(() => {
        this.fullFeedbackDisabled = false;
      }, 1000);
    },
    // 打开查看全部反馈弹窗
    openAllFeedback() {
      this.allFeedbackVisible = true;
    },
    // 查看反馈详情
    async viewFeedbackDetail(item) {
      // 根据回复状态判断显示哪个组件
      if (item.reply_status === 'replied') {
        // 先显示弹窗
        this.feedbackViewVisible = true;
        // 清空当前反馈数据，触发子组件loading
        this.currentFeedback = {};
        // 调用接口获取详细数据
        try {
          this.feedbackLoading = true;
          const response = await getFeedbackDetail(item.id, {
            feedback_id: item.id,
            user_id: this.userId
          });
          if (response && response.code === 200) {
            this.currentFeedback = response.data;
          } else {
            this.$message.error(response.message || '获取反馈详情失败');
            this.feedbackViewVisible = false;
          }
        } catch (error) {
          console.error('获取反馈详情失败:', error);
          this.$message.error('获取反馈详情失败，请稍后重试');
          this.feedbackViewVisible = false;
        } finally {
          this.feedbackLoading = false;
        }
      } else {
        // 否则直接显示详情
        this.currentFeedback = item;
        this.feedbackDetailVisible = true;
      }
    },
    // 处理滚动加载更多
    handleScroll() {
      const feedbackList = this.$refs.feedbackList;
      if (feedbackList) {
        const { scrollTop, scrollHeight, clientHeight } = feedbackList;
        // 当滚动到底部100px时加载更多，且还有更多数据且不在加载中
        if (scrollHeight - scrollTop - clientHeight < 100 && !this.loading && this.hasMore) {
          this.loadMore();
        }
      }
    },
    // 加载更多反馈数据
    async loadMore() {
      if (this.loading || !this.hasMore) return;
      this.page++;
      await this.loadFeedbackList();
    },
    // 获取状态对应的标签类型
    getStatusType(reply_status) {
      switch (reply_status) {
        case 'processing':
          return 'warning';
        case 'replied':
          return 'success';
        case 'none':
          return 'info';
        default:
          return 'info';
      }
    },
    // 获取状态对应的中文文本
    getStatusText(reply_status) {
      switch (reply_status) {
        case 'none':
          return '已收到';
        case 'processing':
          return '处理中';
        case 'replied':
          return '已完成';
        default:
          return '已收到';
      }
    },
    // 检查session缓存中的longId是否在允许的列表中
    checkLongId() {
      try {
        const storedUserId = sessionStorage.getItem('userId');
        if (storedUserId) {
          const userData = JSON.parse(storedUserId);
          const allowedLongIds = ['2103517172', '2103546403', '2103549421'];
          return allowedLongIds.includes(userData.longId);
        }
      } catch (e) {
        console.warn('解析sessionStorage userId失败:', e);
      }
      return false;
    },
    // 关闭悬浮窗（收起）
    closeFloatingChat() {
      this.isCollapsed = false; // 用户客服关闭
      this.isHovering = false; // 用户之声小方块
      // 保存关闭状态到sessionStorage
      try {
        sessionStorage.setItem('myChat', 'false'); // /ai/agent/voicemg 在App中处理
      } catch (error) {
        console.error('保存聊天状态失败:', error);
      }
    },
    // 开始拖拽
    startDrag(event) {
      // 只在鼠标左键点击时开始拖拽
      if (event.button !== 0) return;

      this.isDragging = true;
      this.isClick = true; // 初始化为点击
      this.startX = event.clientX;
      this.startY = event.clientY;

      const floatingButtons = document.querySelector('.floating-buttons');
      if (floatingButtons) {
        const rect = floatingButtons.getBoundingClientRect();
        this.startLeft = rect.left;
        this.startTop = rect.top;
      }

      // 绑定全局鼠标事件，确保鼠标移出元素后仍能继续拖拽
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);

      // 阻止默认事件和冒泡，避免影响点击事件
      event.preventDefault();
    },
    // 拖拽过程
    drag(event) {
      if (!this.isDragging) return;

      // 取消之前的动画帧，避免堆积
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }

      // 使用requestAnimationFrame优化拖拽性能
      this.animationFrameId = requestAnimationFrame(() => {
        const deltaX = event.clientX - this.startX;
        const deltaY = event.clientY - this.startY;

        // 如果移动距离超过一定阈值，认为是拖拽而不是点击
        if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
          this.isClick = false;
          this.hasDragged = true; // 标记已经拖拽过
        }

        const floatingButtons = document.querySelector('.floating-buttons');
        if (floatingButtons) {
          // 计算新位置
          let newLeft = this.startLeft + deltaX;
          let newTop = this.startTop + deltaY;

          // 限制在可视区域内
          const windowWidth = window.innerWidth;
          const windowHeight = window.innerHeight;
          const elementWidth = floatingButtons.offsetWidth;
          const elementHeight = floatingButtons.offsetHeight;

          newLeft = Math.max(0, Math.min(newLeft, windowWidth - elementWidth));
          newTop = Math.max(0, Math.min(newTop, windowHeight - elementHeight));

          // 设置新位置
          floatingButtons.style.left = newLeft + 'px';
          floatingButtons.style.top = newTop + 'px';
          floatingButtons.style.right = 'auto';
          floatingButtons.style.bottom = 'auto';
        }
      });
    },
    // 结束拖拽
    stopDrag() {
      this.isDragging = false;
      // 取消待执行的动画帧
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      // 移除全局鼠标事件监听器
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    // 处理窗口大小变化
    handleWindowResize() {
      const floatingButtons = document.querySelector('.floating-buttons');
      if (floatingButtons && this.hasDragged) {
        const rect = floatingButtons.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const elementWidth = floatingButtons.offsetWidth;
        const elementHeight = floatingButtons.offsetHeight;

        // 检查是否超出窗口边界
        let needsAdjustment = false;
        let newLeft = rect.left;
        let newTop = rect.top;

        // 检查右边界
        if (rect.right > windowWidth) {
          newLeft = windowWidth - elementWidth;
          needsAdjustment = true;
        }

        // 检查下边界
        if (rect.bottom > windowHeight) {
          newTop = windowHeight - elementHeight;
          needsAdjustment = true;
        }

        // 检查左边界
        if (rect.left < 0) {
          newLeft = 0;
          needsAdjustment = true;
        }

        // 检查上边界
        if (rect.top < 0) {
          newTop = 0;
          needsAdjustment = true;
        }

        // 如果需要调整位置
        if (needsAdjustment) {
          floatingButtons.style.left = newLeft + 'px';
          floatingButtons.style.top = newTop + 'px';
          floatingButtons.style.right = 'auto';
          floatingButtons.style.bottom = 'auto';
        }
      }
    },
    // 关闭反馈通知
    closeFeedbackNotice() {
      this.isHovering = false;
      this.isclosing = true;
      setTimeout(() => {
        this.isclosing = false;
      }, 3000);
    },
    handlemgclose() {
      if (this.mouseLeaveTimer) {
        clearTimeout(this.mouseLeaveTimer);
      }
      // 1秒后隐藏tips和关闭按钮
      this.mouseLeaveTimer = setTimeout(() => {
        this.mgclose = false;
      }, 3000);
    },
    // 处理鼠标进入
    handleMouseEnter() {
      // 清除之前的定时器
      if (this.mouseLeaveTimer) {
        clearTimeout(this.mouseLeaveTimer);
        this.mouseLeaveTimer = null;
      }
    },
    // 处理鼠标离开
    handleMouseLeave() {
      // 清除之前的定时器
      if (this.mouseLeaveTimer) {
        clearTimeout(this.mouseLeaveTimer);
      }
      // 1秒后隐藏tips和关闭按钮
      this.mouseLeaveTimer = setTimeout(() => {
        this.isHovering = false;
        this.isclosing = false;
        this.mgclose = false;
      }, 1000);
    }
  }
}
</script>
<style scoped lang="less">
::v-deep .floating-chat-drawer .el-drawer__header {
  color: #666;
  margin-bottom: 0 !important;
}

/* 悬浮按钮样式 */
.floating-buttons {
  width: 46px;
  position: fixed;
  bottom: 103px;
  right: 35px;
  z-index: 2603;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  transition: all 0.3s ease;
}

/* 右上角红色关闭按钮 */
.floating-close-button {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #f56c6c;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  z-index: 10;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f78989;
    transform: scale(1.1);
  }
}

/* 折叠状态 */
.floating-buttons.is-collapsed {
  display: none;

  .floating-buttons-group {
    display: none;
  }

  .expand-button {
    width: 10px;
    height: 46px;
    border-radius: 8px 0 0 8px;
    overflow: hidden;
    background-color: #409eff !important;

    &:hover {
      background-color: #66b1ff !important;
    }

    i {
      font-size: 14px;
      margin-left: -5px;
    }
  }
}

.floating-buttons-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-end;
  transition: all 0.3s ease;
}

.floating-button {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-color: #409eff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  font-size: 24px;
  position: relative;

  &:hover {
    background-color: #66b1ff;
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
  }
}



/* 展开按钮样式 */
.expand-button {
  background-color: #409eff !important;

  &:hover {
    background-color: #66b1ff !important;
  }
}

/* 未读通知标记样式 */
.unread-badge {
  position: absolute;
  top: -2px;
  right: 0px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #f56c6c;
  box-shadow: 0 0 0 1px white;
}

/* 反馈通知样式 */
.feedback-notice {
  width: 236px;
  position: absolute;
  top: -76px;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-3px);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -6px;
    right: 20px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #ffffff;
  }
}

.notice-content {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 240px;
}

.notice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.notice-title {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  display: flex;
  align-items: center;
  gap: 6px;

  i {
    color: #409eff;
    font-size: 14px;
  }
}

.notice-close {
  cursor: pointer;
  font-size: 12px;
  color: #999999;
  transition: color 0.2s ease;

  &:hover {
    color: #333333;
  }

  i {
    font-size: 12px;
  }
}

.notice-text {
  font-size: 12px;
  color: #666666;
  line-height: 1.4;
}

/* 浮窗样式 */
.drawer-content {
  padding: 10px 15px 10px 15px;
  height: calc(100vh - 45px);
  overflow-y: auto;
}

/* 快速反馈输入区域 */
.feedback-input-section {
  margin-bottom: 0px;
}

.feedback-textarea {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 4px;
}

/* 针对textarea内部元素设置高度限制 */
.feedback-textarea ::v-deep .el-textarea__inner {
  min-height: 120px !important;
  max-height: 630px !important;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.submit-btn {
  flex: 1;
  height: 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.full-feedback-btn {
  height: 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 关键词标签样式 */
.keywords-section {
  margin-bottom: 0px;
}

.keyword-tag {
  display: inline-block;
  padding: 4px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: #f8f8f8;
  color: #666;
  border-radius: 12px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #ecf5ff;
    color: #409eff;
    transform: translateY(-1px);
  }
}

/* 单选选项样式 */
.radio-section {
  margin-bottom: 20px;
}

/* 最近反馈记录区域 */
.recent-feedback-section {
  border-top: 1px solid #f0f0f0;
  padding-top: 10px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.section-header i {
  color: #409eff;
  margin-right: 8px;
}

.section-header span {
  font-weight: 500;
}

.time-tag {
  background-color: #ecf5ff;
  color: #409eff;
  margin-left: auto;
}

/* 反馈列表样式 */
.feedback-list {
  height: calc(100vh - 420px);
  overflow-y: auto;
}

.feedback-item {
  padding: 15px;
  margin-bottom: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f0f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.feedback-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.feedback-title {
  font-weight: 500;
  font-size: 14px;
  color: #303133;
  width: 330px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-tag {
  font-size: 12px;
}

.feedback-content {
  font-size: 13px;
  color: #606266;
  line-height: 1.4;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.feedback-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #909399;
}

.feedback-detail {
  color: #409eff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

/* 加载更多样式 */
.loading-more {
  text-align: center;
  padding: 10px;
  font-size: 12px;
  color: #909399;
}

/* 暂无数据样式 */
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #909399;

  i {
    font-size: 48px;
    margin-bottom: 16px;
    color: #dcdfe6;
  }

  div {
    font-size: 14px;
  }
}

/* 查看全部反馈按钮样式 */
.view-all-section {
  margin-top: 10px;
  text-align: center;
}

::v-deep .el-button.view-all-btn {
  width: 100%;
  height: 36px;
  font-size: 14px;
  border-radius: 4px;
  display: block;

  & span {
    display: block;
    text-align: center;
  }
}

.feedback-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  text-align: center;
}

/* 标题图标样式 */
.title-icon {
  color: #409eff;
  margin-right: 8px;
  font-size: 16px;
}
</style>
